export default __webpack_public_path__ + "static/media/react.85d92633.png";